import { OccupationStatus } from '../../types/consultation';

export function applyCaptchaToPayload<T extends Record<string, any>>(payload: T, token?: string): T {
  if (!token) {
    return payload;
  }

  // In dev environments (test.on.ag, localhost without ?captaincaps),
  // the bypass token should not be verified by the backend.
  const isDevBypassToken = token === 'DEV_BYPASS_TOKEN_CAPTCHA_SOLUTION';

  return {
    ...payload,
    otto_solution_key: token,
    verify_captcha: !isDevBypassToken
  };
}

export function normalizeCaptchaFromContactDetails<T extends Record<string, any>>(payload: T): T {
  const token = payload?.contact_details?.otto_solution_key || payload?.contact_details?.['frc-captcha-response'];

  if (payload?.contact_details?.employment === OccupationStatus.Undefined) {
    delete payload.contact_details.employment;
  }

  if (!token) {
    return payload;
  }

  const nextPayload = {
    ...payload,
    contact_details: { ...payload.contact_details }
  };

  delete nextPayload.contact_details.otto_solution_key;
  delete nextPayload.contact_details['frc-captcha-response'];

  return nextPayload;
}
